import { parse } from "date-fns";
import { useState } from "react";
import { Button } from "semantic-ui-react";

import { RDWDetails, useRdwDetailsQuery } from "components";
import "components/RDW/RDW.scss";
import { isDateAfter } from "utils/dateHelperFunctions";

type RDWProps = {
  regNumber?: string;
  country?: string | null;
};

const toRdwDate = (date?: string) => {
  if (!date) return;
  return parse(date, "yyyyMMdd", new Date());
};

const RDWContent = ({ regNumber }: { regNumber?: string }) => {
  const [isRdwDetailsDisplayed, setIsRdwDetailsDisplayed] = useState(false);

  const { rdwDetails, isRdwFetching, fetchRdwDetails } = useRdwDetailsQuery({ regNumber, enabled: true });

  const handleToggleIsRdwDetailsOpen = () => setIsRdwDetailsDisplayed(!isRdwDetailsDisplayed);
  const expiredDate = isDateAfter(new Date(), toRdwDate(rdwDetails?.vervaldatum_tachograaf)) || isDateAfter(new Date(), toRdwDate(rdwDetails?.vervaldatum_apk));

  return (
    <div className="RDW">
      <Button
        className={`-appointment-status ${expiredDate ? "expired" : ""}`}
        size="small"
        loading={isRdwFetching && !isRdwDetailsDisplayed}
        onClick={handleToggleIsRdwDetailsOpen}
      >
        RDW
      </Button>
      <RDWDetails data={rdwDetails} isOpen={isRdwDetailsDisplayed} loading={isRdwFetching} onClose={handleToggleIsRdwDetailsOpen} onRefresh={fetchRdwDetails} />
    </div>
  );
};

export const RDW = ({ regNumber, country }: RDWProps) => {
  if (country !== "NL") return null;

  return <RDWContent regNumber={regNumber} />;
};
